import { render } from "./current-stock.vue?vue&type=template&id=7e65499a&scoped=true"
import script from "./current-stock.vue?vue&type=script&lang=js"
export * from "./current-stock.vue?vue&type=script&lang=js"

import "./current-stock.vue?vue&type=style&index=0&id=7e65499a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e65499a"]])

export default __exports__